import React from "react";
import cx from "./cx";

/**
 * Control segmentado (botones excluyentes).
 *  - items: [{ value, label, count?, className?, pendiente? }] — `pendiente` es el id de la
 *    ficha ds-pendiente de ese item (lo marca rosita y lo deja inerte); `count` pinta el
 *    recuento como hijo aparte atenuado (omitido si no se pasa)
 *  - value / onChange(value)
 *  - readOnly: sin interacción (spans), para mockups y estados solo-lectura
 *  - disabled: siguen siendo botones, pero deshabilitados (estado `:disabled` real,
 *    neutro plano; el foco de teclado no entra). Distinto de `readOnly`, que pinta
 *    spans indistinguibles del estado habilitado.
 */
const RevSegmented = ({ items, value, onChange, readOnly, disabled, className, ...rest }) => (
    <div className={cx('rev-segmented', className)} {...rest}>
        {items.map((item) => {
            const classes = cx('rev-segmented__item', value === item.value && 'is-active', item.pendiente && 'ds-pendiente', item.className);
            const content = <>{item.label}{item.count != null && <span className="rev-segmented__count rev-num">{item.count}</span>}</>;
            return readOnly || item.pendiente
                ? <span key={item.value} className={classes} data-pendiente={item.pendiente}>{content}</span>
                : <button
                    key={item.value}
                    type="button"
                    className={classes}
                    aria-pressed={value === item.value}
                    disabled={disabled || undefined}
                    aria-disabled={disabled ? 'true' : undefined}
                    onClick={() => onChange(item.value)}>{content}</button>;
        })}
    </div>
);

export default RevSegmented;
